<template>
  <div class="nps-flutuante" v-show="!escondePesquisa">
    <!-- Seu componente NPS aqui -->
    <div class="nps-container bg-white rounded">
      <div class="text-right">
        <b-img
          class="pointer"
          src="./img/close.svg"
          @click.prevent="esconderPesquisa()"
        ></b-img>
      </div>
      <div v-show="sucesso" class="text-center mb-2">
        <div class="title">Agradecemos o seu feedback!</div>
        <div class="sub-title mb-2">
          Sua opinião nos ajuda a melhorar a experiência com a Bike Registrada.
        </div>
        <b-img src="./img/feedback-obrigado.svg"></b-img>
      </div>
      <div v-show="!sucesso">
        <!-- Pergunta principal -->
        <div class="title">
          Como você classifica sua experiência com <br />
          a contratação da Bike Registrada?
        </div>

        <!-- Escala com Emojis -->
        <div class="nps-wrapper">
          <div class="emoji-track">
            <div
              @click.prevent="selecionarNota(0)"
              class="emoji-item"
              style="left: 0%"
            >
              <div class="emoji" style="color: #e74c3c">
                <b-img
                  width="30px"
                  v-if="notaSelecionada == 0"
                  src="./img/nervoso1.svg"
                ></b-img>
                <b-img width="30px" v-else src="./img/nervoso.svg"></b-img>
              </div>
              <div class="label">Péssima</div>
              <div
                v-if="notaSelecionada == 0"
                class="linha-vertical-selecionado"
              ></div>
              <div v-else class="linha-vertical"></div>
            </div>
            <div
              @click.prevent="selecionarNota(1)"
              class="emoji-item"
              style="left: 25%"
            >
              <div class="emoji" style="color: #e74c3c">
                <b-img
                  width="30px"
                  v-if="notaSelecionada == 1"
                  src="./img/triste1.svg"
                ></b-img>
                <b-img width="30px" v-else src="./img/triste.svg"></b-img>
              </div>
              <div class="label">Ruim</div>
              <div
                v-if="notaSelecionada == 1"
                class="linha-vertical-selecionado"
              ></div>
              <div v-else class="linha-vertical"></div>
            </div>
            <div
              @click.prevent="selecionarNota(2)"
              class="emoji-item"
              style="left: 50%"
            >
              <div class="emoji" style="color: #e74c3c">
                <b-img
                  width="30px"
                  v-if="notaSelecionada == 2"
                  src="./img/meh1.svg"
                ></b-img>
                <b-img width="30px" v-else src="./img/meh.svg"></b-img>
              </div>
              <div class="label">Média</div>
              <div
                v-if="notaSelecionada == 2"
                class="linha-vertical-selecionado"
              ></div>
              <div v-else class="linha-vertical"></div>
            </div>
            <div
              @click.prevent="selecionarNota(3)"
              class="emoji-item"
              style="left: 75%"
            >
              <div class="emoji" style="color: #e74c3c">
                <b-img
                  width="30px"
                  v-if="notaSelecionada == 3"
                  src="./img/feliz1.svg"
                ></b-img>
                <b-img width="30px" v-else src="./img/feliz.svg"></b-img>
              </div>
              <div class="label">Boa</div>
              <div
                v-if="notaSelecionada == 3"
                class="linha-vertical-selecionado"
              ></div>
              <div v-else class="linha-vertical"></div>
            </div>
            <div
              @click.prevent="selecionarNota(4)"
              class="emoji-item"
              style="left: 100%"
            >
              <div class="emoji" style="color: #e74c3c">
                <b-img
                  width="30px"
                  v-if="notaSelecionada == 4"
                  src="./img/rir1.svg"
                ></b-img>
                <b-img width="30px" v-else src="./img/rir.svg"></b-img>
              </div>
              <div class="label">Ótima</div>
              <div
                v-if="notaSelecionada == 4"
                class="linha-vertical-selecionado"
              ></div>
              <div v-else class="linha-vertical"></div>
            </div>
          </div>

          <div
            class="slider-container"
            :style="sliderBackgroundStyle"
            @mousedown="startDrag"
            @mouseup="stopDrag"
            @mousemove="onDrag"
            ref="slider"
          >
            <div
              class="bolinha"
              :style="getBolinhaStyle()"
              @mousedown.prevent="dragging = true"
            ></div>
          </div>
        </div>

        <!-- Etapas extras aparecem após seleção -->
        <div v-if="notaSelecionada !== null">
          <div class="mb-2 mt-3">
            <hr class="linha-meio" />
          </div>
          <!-- Motivos -->
          <div class="mb-2">
            <div class="sub-title mb-2">Do que você mais gostou?</div>
            <div class="d-flex flex-wrap justify-content-center">
              <button
                v-for="(motivo, i) in motivos"
                :key="i"
                :value="motivo"
                :class="{ active: selected === i }"
                @click.prevent="selecionarMotivo(motivo, i)"
                class="mr-1 mb-1 btn btn-outline-secondary"
              >
                {{ motivo }}
              </button>
            </div>
          </div>

          <!-- Comentário -->
          <b-form-textarea
            v-model="comentario"
            placeholder="Nos conte como foi sua experiência. Adoraríamos saber o que está achando do Bike Registrada!"
            rows="3"
            class="mb-2"
          ></b-form-textarea>

          <!-- Botão Enviar -->
          <div class="text-center">
            <b-button
              :disabled="loading || !motivo"
              class="btn-block"
              variant="success"
              @click.prevent="enviarFeedback()"
            >
              <span
                v-show="loading"
                class="spinner-border spinner-border-sm mr-2"
                role="status"
                aria-hidden="true"
              ></span>
              <span v-show="loading">Enviando feedback</span>
              <span v-show="!loading">Enviar feedback</span>
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "../../config";
import axios from "axios";
export default {
  props: ["idSeguro"],
  data() {
    return {
      config,
      escondePesquisa: false,
      notaSelecionada: null,
      dragging: false,
      comentario: "",
      selected: null,
      motivos: [],
      motivo: null,
      loading: false,
      data: {},
      sucesso: false,
      aplicarLayoutMobile: false,
    };
  },
  created() {
    if (window.innerWidth <= 768) {
      this.aplicarLayoutMobile = true;
    }
  },
  computed: {
    sliderBackgroundStyle() {
      let percent = 0;
      if (!this.aplicarLayoutMobile) {
        if (this.notaSelecionada === 0) percent = 20;
        else if (this.notaSelecionada === 1) percent = 75;
        else if (this.notaSelecionada === 2) percent = 128;
        else if (this.notaSelecionada === 3) percent = 187;
        else if (this.notaSelecionada === 4) percent = 256;

        const max = 256; // valor máximo
        const percentage = Math.round((percent / max) * 100);

        // Gradiente até a porcentagem selecionada
        return {
          background: `linear-gradient(to right, #e74c3c, #f39c12, #2ecc71 ${percentage}%, #e0e0e0 ${percentage}%)`,
        };
      } else {
        if (this.notaSelecionada === 0) percent = 20;
        else if (this.notaSelecionada === 1) percent = 63;
        else if (this.notaSelecionada === 2) percent = 105;
        else if (this.notaSelecionada === 3) percent = 145;
        else if (this.notaSelecionada === 4) percent = 200;


        const max = 200; // valor máximo
        const percentage = Math.round((percent / max) * 100);

        // Gradiente até a porcentagem selecionada
        return {
          background: `linear-gradient(to right, #e74c3c, #f39c12, #2ecc71 ${percentage}%, #e0e0e0 ${percentage}%)`,
        };
      }
    },
  },

  methods: {
    selecionarMotivo(motivo, i) {
      this.motivo = motivo;
      this.selected = i;
    },
    esconderPesquisa() {
      this.escondePesquisa = true;
    },
    selecionarNota(nota) {
      if (this.notaSelecionada != nota) {
        this.motivo = null;
        this.selected = null;
      }

      this.notaSelecionada = nota;

      const motivosPorNota = {
        0: { descricao: "pessima", motivos: ["Informações puco claras", "Fluxo confuso", "Lentidão ou travamentos", "Interface complicada", "outros"] },
        1: { descricao: "ruim",    motivos: ["Informações puco claras", "Fluxo confuso", "Lentidão ou travamentos", "Interface complicada", "outros"] },
        2: { descricao: "media",   motivos: ["Facilitar o fluxo", "Reduzir o número de passos", "Ajustar layout ou navegação", "Melhorar forma de pagamento", "Explicar melhor as etapas", "outros"] },
        3: { descricao: "boa",     motivos: ["Facilitar o fluxo", "Reduzir o número de passos", "Ajustar layout ou navegação", "Melhorar forma de pagamento", "Explicar melhor as etapas", "outros"] },
        4: { descricao: "otima",   motivos: ["Informações claras", "Facilidade de contratação", "Rapidez", "Valor do seguro", "Segurança", "Eficiência", "Outros"] },
      };

      if (motivosPorNota[nota] !== undefined) {
        this.data.descricaoExperiencia = motivosPorNota[nota].descricao;
        this.motivos = motivosPorNota[nota].motivos;
      }
    },
    getBolinhaStyle() {
      const posicoes = {
        desktop: { 0: 20, 1: 79,  2: 138, 3: 197, 4: 256 },
        mobile:  { 0: 20, 1: 65,  2: 110, 3: 155, 4: 200 },
      };
      const mapa = this.aplicarLayoutMobile ? posicoes.mobile : posicoes.desktop;
      const percent = this.notaSelecionada !== null ? (mapa[this.notaSelecionada] ?? 0) : 0;
      return { left: `${percent}px` };
    },
    startDrag(event) {
      this.dragging = true;
      this.onDrag(event);
    },
    stopDrag() {
      this.dragging = false;
    },
    onDrag(event) {
      if (!this.dragging) return;

      const slider = this.$refs.slider;
      const rect = slider.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const percent = Math.max(0, Math.min(x / rect.width, 1));
      this.notaSelecionada = Math.round(percent * 4); // Ajustando o número de notas fixas
    },
    async enviarFeedback() {
      try {
        this.loading = true;
        this.data.idSeguro = this.idSeguro;
        this.data.descricaoTag = this.motivo;
        this.data.descricaoComentario = this.comentario;
        this.data.descricaoPasso = "OBRIGADO";
        if (this.aplicarLayoutMobile) {
          this.data.jornada = "MOBILE";
        } else {
          this.data.jornada = "DESKTOP";
        }

        await axios.post(`${config.API_URLV2}/feedback`, this.data);
        this.sucesso = true;
        this.notaSelecionada = null;
        this.comentario = "";
      } catch (error) {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.nps-container {
  max-width: 455px; /* 650px - 30% */
  margin: 0 auto;
}
.label {
  color: #425994;
  font-size: 9.8px;
  text-align: center;
  font-weight: 500;
  margin-bottom: 1px;
}
.nps-flutuante {
  position: fixed;
  bottom: 0px;
  right: 24px; /* <-- Aqui está a mudança */
  z-index: 999;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 24px rgba(42, 35, 35, 0.326);
  padding-right: 24px; /* 35px - 30% */
  padding-left: 24px;
  padding-top: 14px;
  padding-bottom: 12px;
  max-width: 424px; /* 520px - 30% */
  width: 100%;
  transition: transform 0.3s ease-in-out;
  transform: translateY(50px);
  opacity: 0;
  animation: slideUp 0.3s forwards ease-in-out;
}

@keyframes slideUp {
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
.slider {
  width: 100%;
  appearance: none;
  height: 5.6px; /* 8px - 30% */
  border-radius: 7px;
  background: linear-gradient(to right, #e74c3c, #f39c12, #2ecc71);
  outline: none;
  margin: 0;
}

.slider::-webkit-slider-thumb {
  appearance: none;
  background: white;
  border: 3px solid #2ecc71;
  width: 12.6px; /* 18px - 30% */
  height: 12.6px;
  border-radius: 50%;
  cursor: pointer;
  margin-top: -5px;
}

.slider::-moz-range-thumb {
  background: white;
  border: 3px solid #2ecc71;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  cursor: pointer;
}

.linha-vertical {
  width: 3px;
  height: 24px; /* Aumente a altura para alinhar com a bolinha */
  background-color: #cfcfcf;
  margin-bottom: -18px; /* Ajuste para alinhar com a bolinha */
}

.nps-wrapper {
  width: 100%;
  padding-left: 50px;
  padding-right: 50px; /* Garante que o componente ocupe uma largura maior */
  margin: 0 auto;
}

.emoji-track {
  height: 62px; /* 80px - 30% */
  position: relative;
  margin-left: 20px;
  margin-right: 20px;
  cursor: pointer;
  margin-bottom: -1px;
}

.emoji-item {
  position: absolute;
  top: 0;
  transform: translateX(-50%);
  text-align: center;
}

.linha-vertical {
  width: 2px;
  height: 14px; /* 20px - 30% */
  background-color: #ccc;
  margin: 0 auto 4px;
}
.linha-vertical-selecionado {
  width: 2px;
  height: 14px; /* 20px - 30% */
  background-color: #2ecc71;
  margin: 0 auto 4px;
}
.linha-meio {
  background-color: #e2e8f0;
  margin: 0 auto 4px;
}

.emoji {
  font-size: 1.5rem; /* Aumenta o tamanho do emoji */
}

.slider-container {
  position: relative;
  width: 100%; /* A barra ocupa toda a largura disponível */
  max-width: 900px; /* Aumenta a largura máxima da barra */
  height: 5px;
  background: linear-gradient(to right, #e74c3c, #f1c40f, #2ecc71);
  border-radius: 5px;
  cursor: pointer;
}

.bolinha {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 14px; /* Tamanho maior da bolinha */
  height: 14px; /* Tamanho maior da bolinha */
  background: white;
  border: 4px solid #2ecc71;
  border-radius: 50%;
  z-index: 10;
}
.title {
  color: #425994;
  font-size: 16px !important;
  text-align: center;
  font-weight: 600;
  margin-bottom: 12px;
}

.sub-title {
  color: #425994;
  font-size: 12px;
  text-align: center;
  font-weight: 600;
}
.btn-outline-secondary {
  color: #425994;
  border-color: #425994;
  font-family: Inter;
  font-weight: 500;
  font-size: 14px;
  line-height: 140%;
  vertical-align: middle;
}
.btn-outline-secondary:hover {
  color: #fff;
  background-color: #425994;
  border-color: #425994;
}
.btn-outline-secondary.active,
.btn-outline-secondary:active {
  color: #fff;
  background-color: #425994 !important;
  border-color: #425994 !important;
  box-shadow: #fff !important;
}
.btn {
  font-size: 12px;
  padding: 4px 8px;
}
textarea {
  font-size: 12px;
  border-color: #e2e8f0;
  resize: none;
}
.btn:focus {
  box-shadow: none !important;
  outline: none !important;
}

@media (max-width: 768px) {
  .nps-flutuante {
    right: 0px; /* Ajusta a posição para a direita em telas menores */
    padding-top: 6px;
    padding-bottom: 30px; /* Ajusta o padding inferior */
    padding-right: 20px;
    padding-left: 20px;
  }
  .title {
    font-size: 14px !important;
  }
}
</style>
